import React, { useState } from "react";
import "./Contact.css";
import heroImage from "../../assets/images/contact.jpeg";

/*const API_BASE = "https://localhost:7286";*/
const API_BASE = "https://api.yadnyahandloom.com";
/*const API_BASE = "https://yadnya.jbjmaicloud.com";*/

const nameRegex = /^[A-Za-z\s]{3,50}$/;

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;

const Contact = () => {
  // ==========================
  // PREMIUM POPUP
  // ==========================

  const showPopup = (type, message) => {
    const popup = document.createElement("div");

    popup.className = `custom-popup ${type}`;

    popup.textContent = message;

    document.body.appendChild(popup);

    setTimeout(() => {
      popup.classList.add("hide");

      setTimeout(() => {
        if (document.body.contains(popup)) {
          document.body.removeChild(popup);
        }
      }, 400);
    }, 3000);
  };

  // ==========================
  // CONTACT FORM
  // ==========================

  const sendEmail = async (e) => {
    e.preventDefault();

    const form = new FormData(e.target);

    const data = {
      name: form.get("from_name"),
      email: form.get("from_email"),
      message: form.get("message"),
    };

    if (!nameRegex.test(data.name.trim())) {
      showPopup("error", "Enter a valid name.");
      return;
    }

    if (!emailRegex.test(data.email.trim())) {
      showPopup("error", "Enter a valid email address.");
      return;
    }

    if (data.message.trim().length < 10) {
      showPopup("error", "Message should be at least 10 characters.");
      return;
    }

    try {
      const res = await fetch(`${API_BASE}/api/email/enquiry`, {
        method: "POST",

        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify(data),
      });

      if (res.ok) {
        showPopup("success", "Message sent successfully.");

        e.target.reset();
      } else {
        showPopup("error", "Failed to send enquiry.");
      }
    } catch (err) {
      console.error(err);

      showPopup("error", "Server error. Please try again.");
    }
  };

  // ==========================
  // JSX STARTS BELOW
  // ==========================

  return (
    <>
      <section className="contact-page">
        {/* ================= HERO ================= */}

        <section className="contact-hero">
          <div className="contact-hero-overlay">
            <span className="contact-subtitle">CONTACT US</span>

            <h1>
              Let's Weave
              <br />A Beautiful Conversation
            </h1>

            <p>
              Whether you're searching for an exquisite handloom saree, planning
              a bridal purchase, or seeking a personalized shopping experience,
              we're here to assist you.
            </p>
          </div>
        </section>

        {/* ================= INTRO ================= */}

        <section className="contact-intro">
          <div className="container">
            <div className="contact-intro-wrapper">
              {/* LEFT */}

              <div className="contact-content">
                <span>GET IN TOUCH</span>

                <h2>
                  We'd Love
                  <br />
                  To Hear From You
                </h2>

                <p>
                  Every saree has a story, and every customer becomes part of
                  our journey.
                </p>

                <p>
                  Whether you need styling assistance, wedding consultation,
                  bulk orders, or wish to visit our showroom, our team is always
                  happy to help.
                </p>

                <div className="contact-features">
                  <div className="contact-feature">
                    <h4>Premium Consultation</h4>

                    <p>Personalized saree selection assistance.</p>
                  </div>

                  <div className="contact-feature">
                    <h4>Worldwide Shipping</h4>

                    <p>Secure delivery across India & abroad.</p>
                  </div>

                  <div className="contact-feature">
                    <h4>Authentic Handloom</h4>

                    <p>
                      Genuine handcrafted collections directly from artisans.
                    </p>
                  </div>
                </div>
              </div>

              {/* RIGHT */}

              <div className="contact-info-grid">
                <div className="info-card">
                  <div className="info-icon">📍</div>

                  <h3>Visit Us</h3>

                  <p>Chhatrapati Sambhajinagar</p>

                  <p>Kudal, Sindhudurg</p>
                </div>

                <div className="info-card">
                  <div className="info-icon">📞</div>

                  <h3>Call Us</h3>

                  <a href="tel:+917720089312">+91 7720089312</a>
                </div>

                <div className="info-card">
                  <div className="info-icon">✉️</div>

                  <h3>Email</h3>

                  <a href="mailto:sales@yadnyahandloom.com">
                    sales@yadnyahandloom.com
                  </a>
                </div>

                <div className="info-card">
                  <div className="info-icon">💬</div>

                  <h3>WhatsApp</h3>

                  <a
                    href="https://wa.me/917720089312"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Chat With Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ================= MAP + FORM ================= */}

        <section className="contact-section">
          <div className="container">
            <div className="contact-grid-wrapper">
              {/* MAP */}

              <div className="contact-map">
                <iframe
                  title="map"
                  src="https://maps.google.com/maps?q=Ratnagiri&output=embed"
                />
              </div>

              {/* FORM */}

              <div className="contact-form-card">
                <span>SEND MESSAGE</span>

                <h2>Start Your Conversation</h2>

                <form onSubmit={sendEmail}>
                  <div className="form-row">
                    <input
                      name="from_name"
                      placeholder="Your Name"
                      required
                      minLength="3"
                      maxLength="50"
                      pattern="[A-Za-z ]+"
                    />

                    <input
                      type="email"
                      name="from_email"
                      placeholder="Email Address"
                      required
                    />
                  </div>

                  <textarea
                    name="message"
                    placeholder="Tell us how we can help you..."
                    required
                  />

                  <button type="submit" className="contact-submit-btn">
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Contact;
